import { OnInit, HostListener, OnDestroy } from '@angular/core';
import { NotificationService } from './shared/services/notification.service';
import { Component, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import swal from 'sweetalert2';

import { Router, Event, NavigationStart, NavigationEnd, NavigationError, NavigationCancel } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { GlobalConfig } from './shared/constant/app.constant';
// import { Observable } from 'rxjs/Observable';
// import { Subscription } from 'rxjs/Subscription';
import { Observable, Subscription, interval, Subject} from 'rxjs'; 
import { takeUntil } from 'rxjs/operators';
import { AuthenticationService } from './admin/services/authentication.service';
import { LoadingService } from './shared/services/loading.service';
// import { DialogService } from 'app/shared/services/dialog.service';


@Component({
    selector: 'app-root',
    template: `<router-outlet></router-outlet>
    <fintrakbanking-message [title]="title" [message]="message" [show]="show" [cssClass]="cssClass" (closeEvent)="hideMessage()"></fintrakbanking-message>
    <p-dialog [closeOnEscape]="false"  [(visible)]="lockScreen" modal="modal" width="400" [styleClass]="'screenlock-dialog'" [responsive]="true">
                <app-screen-lock [active]="lockScreen" *ngIf="lockScreen"  [@fadein]="screenLockState"></app-screen-lock>
    <div *ngIf="loading" id="page-preloader" style="display:block"><span class="spinner"></span></div>`,
       //    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent {

    notificationList: any[] = [];
    loading: boolean;
    domIsReady: boolean = false;
    lockScreen =  false;
    screenLockState = 'void';
  message: string;
  title: string;
  cssClass: string;
  show: boolean = false;
  private validationInterval: any; // Store the interval ID
 
    constructor(
        private noticeService: NotificationService,
        private router: Router,private changeRef: ChangeDetectorRef,
        private titleService: Title,
        private authService: AuthenticationService,
        private loadingService: LoadingService
    ) {
        router.events.subscribe((routerEvent: Event) => { this.checkRouterEvent(routerEvent); });
        this.validateLogin();
    }

    ngOnInit(): void {
        //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
        //Add 'implements OnInit' to the class.
        this.authService.lockScreen$.subscribe((message) => {
         
            if (message) {
    
                if (message.status == 0 ) {
                    this.loadingService.hide();
               // this.showMessage("Connection was reset. Please try again", "error", "Fintrak Banking");
                } 
                
                
                else if (message.status === 504 ) {
                    this.loadingService.hide();
               // this.showMessage("Network error please try again", "error", "Fintrak Banking");
                }else {
                    this.loadingService.hide();
                this.activateScreenLock();
              }
    
            } else {
              this.deactivateScreenLock();
            }
          });
       
    }

    showMessage(message: string, cssClass: string, title: string) {
        this.message = message;
        this.title = title;
        this.cssClass = cssClass;
        this.show = true;
    }
  
    hideMessage() {
      this.show = false;
  }
  
      activateScreenLock() {
          if(this.router.url.indexOf("login") === -1) {
            this.lockScreen = true;
            this.screenLockState = 'null';
            this.authService.lockScreen();
          }
          else{
              this.deactivateScreenLock();
          }
       
      }
  
      deactivateScreenLock() {
        this.lockScreen = false;
        this.screenLockState = 'void';
        this.authService.unlockScreen();
  
      }

    checkRouterEvent(routerEvent: Event): void {
        if (routerEvent instanceof NavigationStart && this.domIsReady) { 
            // 

            this.loading = true;
            
        }

        if (routerEvent instanceof NavigationEnd
            || routerEvent instanceof NavigationCancel
            || routerEvent instanceof NavigationError
        ) {
            this.loading = false;
        }
    }

    ngAfterViewInit() {
        //this.getNotifications();
        // if (this.notificationList.length > 0) {
        //     this.showNotificationPopUp();
        // }
        // setTimeout(() => { this.startLoader(); }, 10000);
        // this.setTitle(`${GlobalConfig.TITLE_HEADER}`);


        //   var modalPromise =   this.dialogSvc.open("Session Expiring!", "Your session is about to expire. Do you need more time?", true, "Yes", "No");
        //   var newObservable = Observable.fromPromise(modalPromise);
        //   newObservable.subscribe(
        //       (res) => {
        //           if (res === true) {
        //               
        //               this._status = "Session was extended.";
        //               this.idleTimeoutSvc.resetTimer();
        //               this.startCounter();
        //               this.changeRef.markForCheck();
                      
        //           } else {
        //               
        //               this._status = "Session was not extended.";
        //               this.changeRef.markForCheck();
        //           }
        //       },
        //       (reason) => {
        //           
        //           this._status = "Session was not extended.";
        //           this.changeRef.markForCheck();
        //       }
        //   );
     
    }

    startLoader() {
        this.domIsReady = true;
    }

    showNotificationPopUp() {
        setInterval(() => {
            swal('Notification', `You have ${this.notificationList.length} approvals waiting for you`, 'info');
        }, (1000 * 20))
    }

    // getNotifications(): {
    //     this.noticeService.getNotificationList()
    //         .subscribe((res) => { 
    //             //this.notificationList = res; 
    //         });
    // }

    public setTitle(newTitle: string) {
        this.titleService.setTitle(newTitle);
    }

     invalidLogin: boolean = false;
    validateLogin() {
        let currentUser = this.authService.getUserInfo();
        if (!this.invalidLogin && currentUser != null) {
            // Start interval and store the ID
            this.validationInterval = setInterval(() => {
                this.validateLoginSession();
            }, 1000 * 30);
        }
    }

    validateLoginSession() {
        this.authService.validateLoginSession().subscribe((res: any) => {
            if (res.result == true) {
                this.authService.removealliteminlocalStore();
                this.invalidLogin = true;
                // Clear the interval when session is invalid
                this.clearValidationInterval();
                this.router.navigate(['/auth/login']);
                swal(`${GlobalConfig.APPLICATION_NAME}`, 'Unauthorized Access! Invalid login session detected', 'info');
            }
        });
    }
    // Method to clear the validation interval
    private clearValidationInterval() {
        if (this.validationInterval) {
            clearInterval(this.validationInterval);
            this.validationInterval = null;
        }
    }
    // Clean up on component destruction
    ngOnDestroy() {
        this.clearValidationInterval();
    }

}


// <div *ngIf="loading" id="page-preloader" style="display:block"><span class="spinner"></span></div>